export default __webpack_public_path__ + "static/media/logo_white.0fe52b23.svg";